import { render, staticRenderFns } from "./FighterSelected.vue?vue&type=template&id=7532df72&scoped=true"
import script from "./FighterSelected.vue?vue&type=script&lang=js"
export * from "./FighterSelected.vue?vue&type=script&lang=js"
import style0 from "./FighterSelected.vue?vue&type=style&index=0&id=7532df72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532df72",
  null
  
)

export default component.exports